export const setSessionTimeout = (setSessionTimerCount, setMode) => {
    setSessionTimerCount(600);
    setTimeout(() => {
        sessionStorage.removeItem("deleteUserToken");
        setMode('form');
    }, 600000);
}
